<!-- =========================================================================================
  File Name: Speaker-Edit.vue
  Description: Speaker Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.header-custome{padding-left: 2px;}
</style>
<template>
  <div id="page-speaker-edit" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Edit Speaker</h3>
    </div>
    <vs-alert color="danger" title="Attendee Not Found" :active.sync="speaker_not_found">
      <span>Attendee record with id: {{ $route.params.speakerId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-speaker-list'}" class="text-inherit underline">All Speakers</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="speaker_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs position="left" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab v-model="activeTab" label="Account" icon-pack="feather" icon="icon-speaker">
            <div class="tab-text">
              <speaker-edit-tab-account v-if="speaker_data" :data="speaker_data" @activateTab="setActiveTab" />
            </div>
          </vs-tab>
          
          <vs-tab v-model="activeTab" label="Resources" icon-pack="feather" icon="icon-upload">
            <div class="tab-text">
              <speaker-resource v-if="speaker_data" :data="speaker_data" @activateTab="setActiveTab" />
            </div>
          </vs-tab>

          <vs-tab v-model="activeTab" label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <speaker-edit-tab-social v-if="speaker_data" :data="speaker_data" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import SpeakerEditTabAccount from './SpeakerEditTabAccount.vue';
import SpeakerEditTabSocial from './SpeakerEditTabSocial.vue';
import SpeakerResource from './SpeakerResource.vue'

// Store Module
import moduleSpeakerManagement from '@/store/speaker-management/moduleSpeakerManagement.js'
import moduleAttendeeManagement from '@/store/attendee-management/moduleAttendeeManagement.js'

export default {
  components: {
    SpeakerEditTabAccount,
    SpeakerEditTabSocial,
    SpeakerResource
  },
  data () {
    return {
      speaker_data: null,
      speaker_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.speaker_data = null;
      this.fetch_speaker_data(this.$route.params.SpeakerId)
    }
  },
  methods: {
    setActiveTab(val){
      this.activeTab = val;
    },
    fetch_speaker_data (SpeakerId) {
      //console.log(SpeakerId)
      this.$store
        .dispatch('speakerManagement/fetchSpeaker', SpeakerId)
        .then(res => {
        //console.log(res.data)
          this.speaker_data = res.data
        })
        .catch(err => {
          /*if (err.response.status === 404) {
            this.speaker_not_found = true
            return
          }*/
          //console.log(err)
        })
    }
  },
  created () {
    //debugger
    // Register Module SpeakerManagement Module
       if (this.$route.params.SpeakerId == undefined) {
      this.$router.push({ name: "speakers" }).catch(() => {});
    } else {
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule('attendeeManagement', moduleAttendeeManagement)
      moduleAttendeeManagement.isRegistered = true
    }
    if (!moduleSpeakerManagement.isRegistered) {
      this.$store.registerModule('speakerManagement', moduleSpeakerManagement)
      moduleSpeakerManagement.isRegistered = true
    }
    this.fetch_speaker_data(this.$route.params.SpeakerId)
    }
  }
}
</script>